module.exports = __webpack_public_path__ + "img/settings.859f48ec.svg";